import ClickCapture from "./ClickCapture";

export default ClickCapture;
